import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { trim } from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { CostService } from "../../../services/cost.service";

@Component({
  selector: "costingSample",
  templateUrl: "./costingSample.html",
})
export class CostingSample {
  row: any;
  data: any;
  myModel = true;
  ischeck = false;
  categoryList : any 
  costdata: any = {
    brand: "",
    sample_no: "",
    width: "",
    shade: "",
    making_cost: 0,
    cost_sam_type: "",
    trims: 0,
    extras: 0,
    ischecked: false,
    profit_per: 0,
    round_off: 0,
    mrp_per: 0,
    rnd: 0,
    grand_total: 0,
    ap_grand_total: 0,
    ap_category: "",
    other_category: "",
  };
  designList: any;
  swatchList: any = [{}];
  categoryData: any;
  matchList: any = [{}];
  mat3PartList: any;
  mat2PartList: any;
  mat1PartList: any;
  pipingPartList: any;
  chk_design: any;
  matchPartList: any = [];
  saveDetect: boolean = false;
  sampleColorList: any;
  colorList: any = [{}];
  matchingList: any = [];
  rateData: any = {};
  shadeList: any;
  isLoading: boolean = false;
  saveEvent: any;
  mode: string;
  type: any;

  accessoriesList = [
    "BUTTON",
    "THREAD",
    "COLLAR CANVAS",
    "KAJA THREAD",
    "BUTTON THREAD",
    "PLK",
    "CLR-UP",
    "CLR-DN",
    "BND DOWN",
    "BAND UP",
    "CUFF CANVAS",
    "MAIN LABEL",
    "EXTRA LABEL",
    "WASH CARE",
    "BONE",
    "BUT PATTI",
  ];
  sample: any = {};
  itemList: any;
  fitList = [
    { fit: "SLIM FIT" },
    { fit: "CASUAL FIT" },
    { fit: "COMFORT FIT" },
  ];

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    // let costData = Object.assign({}, val['data']);
    // this.costdata = costData;

    if (this.mode == "Edit" || this.mode == "View") {
      this.saveEvent = val["data"].tabevent;
      let costData = Object.assign({}, val["data"]);
      this.chk_design = costData.sample_no;
      this.costdata = costData;
      //  this.onEnterSampleNo(this.costdata.sample_no);
      //    this.onSelectColor(this.costdata.sample_color)
      this.getDesignList(this.costdata.cost_samp_id);
      this.getColorList();
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("shadeAuto") shadeAuto;
  @ViewChild("fitAuto") fitAuto;

  checkCtrl: FormControl = new FormControl();
  shadeCtrl: FormControl = new FormControl();
  fitCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private costservice: CostService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      usage_det: "",
      design_no: "",
      shade: "",
      consumption: "",
      rate: "",
      rnd: 0,
      round_off: 0,
    };
    this.costdata.making_cost = 0;
    this.costdata.extras = 0;
    this.costdata.trims = 0;

    this.data = {
      groupList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.groupList.push(row);
  }
  ngOnInit() {
    if (this.mode == "Add") {
      this.costdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
      this.costdata.grand_total = 0;
      this.costdata.ap_grand_total = 0;
    }
    this.getCategory();
    this.getMatchinglist();
    this.tableScroll();
  }

  getMatchinglist() {
    this.costservice.getMatchingList({}).then((res: any) => {
      this.matchingList = res.data;

      console.log("check Matchdata",this.matchingList)
    });

    
  }

  tableScroll() {
    $(".ratebox").height(window.innerHeight - 370);
    if (window.innerWidth > 1500) {
      $(".techstyip").width(window.innerWidth - 1025);
    } else {
      $(".techstyip").width(window.innerWidth - 865);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#sample_no").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getAuto() {
    this.costservice.getAuto({}).then((res: any) => {
      this.costdata.ref_no = res;
    });
  }

  calcCons(parts, ind) {
    for (let j = 0; j < this.matchingList.length; j++) {
      if (parts == this.matchingList[j].parts) {
        this.matchList[ind]["cons"] = (
          this.matchingList[j]["mtr"] / this.matchingList[j]["qty"]
        ).toFixed(2);
      }

    }
      //Piping Part Not Match In MasterData(matchinglist) its Comefrom create Design Number Value.
    if(typeof(parts)== 'number'){
      this.matchList[ind]["cons"] = this.pipingPartList
    }
    this.calcMatchRate(parts, ind);
  }
  calcMatchRate(part, ind) {
    if (this.mat1PartList.indexOf(part) > -1) {
      // match 1
      let mat1_des_no = this.designList[0]["mat1_des_no"],
        params = {
          des_no: mat1_des_no,
        };
      this.costservice.getMatchrate(params).then((res: any) => {
        this.matchList[ind]["rate"] =
          res.data.rate * this.matchList[ind]["cons"];
        this.calcMatchTot();
      });
    } else if (this.mat2PartList.indexOf(part) > -1) {
      let mat2_des_no = this.designList[0]["mat2_des_no"],
        params = {
          des_no: mat2_des_no,
        };
      this.costservice.getMatchrate(params).then((res: any) => {
        this.matchList[ind]["rate"] =
          res.data.rate * this.matchList[ind]["cons"];
        this.calcMatchTot();
      });
    } else if (this.mat3PartList.indexOf(part) > -1) {
      let mat3_des_no = this.designList[0]["mat3_des_no"],
        params = {
          des_no: mat3_des_no,
        };
      this.costservice.getMatchrate(params).then((res: any) => {
        this.matchList[ind]["rate"] = res.data * this.matchList[ind]["cons"];
        this.calcMatchTot();
      });
    } else if (this.pipingPartList) {
      let piping_des_no = this.designList[0]["piping_des_no"],
        params = {
          des_no: piping_des_no,
        };
      this.costservice.getMatchrate(params).then((res: any) => {
        this.matchList[ind]["rate"] =
          res.data.rate * this.matchList[ind]["cons"];
        this.calcMatchTot();
      });
    }
  }

  calcMatchTot() {
    let totRate = 0;
    for (let i = 0; i < this.matchList.length; i++) {
      this.matchList[i]["rate_value"] = this.matchList[i]["rate"] * 2
      totRate += this.matchList[i]["rate_value"];
    }
    this.costdata.total_matchrate = totRate.toFixed(2);
    this.calcRate();

  }
  calcGrandMatchTot(){
    let totRate = 0;
    for (let i = 0; i < this.matchList.length; i++) {
      totRate += this.matchList[i]["rate_value"];
    }
    this.costdata.total_matchrate = totRate.toFixed(2);
    this.calcRate();
  }
  onSelectColor(color) {
    let params = {
      color: color,
      sample_no: this.costdata.sample_no,
      fab_design: this.costdata.fab_design,
    };
    console.log(params);
    this.costservice.getMatchingDesign(params).then((res: any) => {
      this.designList = res.data;
      this.calcRate();
    });
  }

  oncheckemptyrow() {
    let match = this.matchList,
      color = this.colorList;
    let matList = [],
      colList = [];
    for (let i = 0; i < match.length; i++) {
      if (match[i].match_color != "") {
        matList.push(match[i]);
      }
    }
    for (let i = 0; i < color.length; i++) {
      if (color[i].color != "") {
        colList.push(color[i]);
      }
    }
    this.matchList = matList;
    this.colorList = colList;
    this.onSaveCosting();
  }

  onSaveCosting(): void {
    if (this.costdata.shirtdno == "") {
      swal("Shirt Design No cannot be empty!");
    }
    if (
      this.costdata.ischecked == "NO" ||
      this.costdata.cost_sam_type == "" ||
      this.costdata.other_category == "" ||
      this.costdata.ap_category == ""
    ) {
      swal("Make sure that the sample ok is checked!");
    } else {
      let params: any = Object.assign({}, this.costdata);
      params["total_matchrate"] = this.costdata.total_matchrate || 0;
      params["tabevent"] = undefined;
      params["matchList"] = this.matchList
        ? JSON.stringify(this.matchList)
        : "";
      params["colorList"] = JSON.stringify(this.swatchList);

      params["ac_date"] = this.datePipe.transform(
        params["ac_date"],
        "yyyy-MM-dd"
      );
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Costing?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.costservice
          .saveCosting(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "error",
                title: "ALREADY EXISTS",
                body: res.message,
              });
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  checkPurchaseSwatch(sample_no) {
    if(this.mode == "Edit"){

      if(this.chk_design != sample_no){

        swal("PLEASE ENTER SAME SAMPLE NO FOR EDIT MODE");
        return
      }

    }
    let params = {
      sample_no: sample_no,
    };

    this.costservice.checkPurchaseSwatch(params).then((res: any) => {
      if (res.success) {
        

        this.costdata.brand = res.data.brand;
        this.getCategory();
        this.onEnterSampleNo(this.costdata.sample_no);
      } else {
        this.costdata.sample_no = "";
        swal("Please Enter Swatch first");
      }
    });
  }

  onEnterSampleNo(sample_no) {
    let params = {
      sample_no: sample_no,
    };
    this.costservice.onClickSampleNo(params).then((res: any) => {
      // this.costdata.mdesign_no = '';
      // if (res.data && res.data.grn_no) (For Jgrn Entry)
      if (res.data) {
        this.costdata.brand = res.data.brand;
        this.costdata.width = res.data.width;
        this.costdata.style = res.data.style;
        this.costdata.fab_design = res.data.fab_design_no;
        this.costdata.fit = res.data.fit;
        this.costdata.cost_sam_type = res.data.shirt_des_type;
        this.costdata.shirt_design = res.data.shirt_design_no;
        this.costdata.samp_id = res.data.samp_id;
        this.costdata.cons = res.data.mrp_cons;
        this.costdata.party_code = res.data.des_no;
        this.costdata.party_name = res.data.party_name;
        this.costdata.shirt_type = res.data.shirt_type;
        this.costdata.rate = res.data.rate;
        this.costdata.lc_rate = res.data.lc_rate;
        this.sampleColorList = res.data.sample_color.split(",");
        this.mat1PartList = res.data.mat1_part.split(",");
        this.mat2PartList = res.data.mat2_part.split(",");
        this.mat3PartList = res.data.mat3_part.split(",");
        this.pipingPartList = res.data.piping;
        this.matchPartList = this.mat1PartList
          .concat(this.mat2PartList)
          .concat(this.mat3PartList)
          .concat(this.pipingPartList);
        console.log(this.matchPartList);
        this.getColorList();
      } else {
        this.costservice.onClickSamplejgrn(params).then((res: any) => {
          this.costdata.brand = res.data.brand;
          this.costdata.width = res.data.width;
          this.costdata.style = res.data.style;
          this.costdata.fab_design = res.data.fab_design_no;
          this.costdata.fit = res.data.fit;
          this.costdata.shirt_design = res.data.shirt_design_no;
          this.costdata.samp_id = res.data.samp_id;
          this.costdata.cons = res.data.mrp_cons;
          this.costdata.party_code = res.data.des_no;
          this.costdata.party_name = res.data.party_name;
          this.costdata.shirt_type = res.data.shirt_type;
          this.costdata.rate = res.data.rate;
          this.costdata.lc_rate = (this.costdata.rate * 7) / 100;
          this.sampleColorList = res.data.sample_color.split(",");
          this.mat1PartList = res.data.mat1_part.split(",");
          this.mat2PartList = res.data.mat2_part.split(",");
          this.mat3PartList = res.data.mat3_part.split(",");
          this.pipingPartList = res.data.piping;
          this.matchPartList = this.mat1PartList
            .concat(this.mat2PartList)
            .concat(this.mat3PartList)
            .concat(this.pipingPartList);
          console.log(this.matchPartList);
          this.getColorList();
        });
      }
    });
  }

  getColorList() {
    let params = {
      shirt_no: this.costdata.shirt_design,
    };
    this.costservice.getColorList(params).then((res: any) => {
      
      this.swatchList = res.data;
      //       this.sampleColorList = res.data;
    });
  }

  onSelectShade(shade) {
    // this.itemList=[];
    let params = {
      design_no: this.costdata.mdesign_no,
      shade: shade,
      sample_no: this.costdata.sample_no,
    };

    this.costservice.onSelectShade(params).then((res: any) => {
      if (res.data.length == 0) {
        this.costdata.samp_id = "";

        //  this.costdata.mshade = res.data[0].mshade;
        this.costdata.width = "";
        this.costdata.rate = "";
        this.costdata.fconsumption = "";
        this.costdata.brand = "";
        this.costdata.style = "";
        this.costdata.tech_style = "";
        this.costdata.kaja = "";
        this.costdata.button = "";
        this.costdata.but_thread = "";
        this.costdata.style_no = "";
        this.sample = {};
        this.data.groupList = [
          {
            usage_det: "",
            design_no: "",
            shade: "",
            consumption: "",
            rate: "",
            rnd: 0,
            round_off: 0,
          },
        ];
        this.costdata.cloth_rate = "";
        this.costdata.matchRate = "";
        this.costdata.clothRate = "";
        this.costdata.match_rate = "";
        this.costdata.making_cost = "";
        this.costdata.trims = "";
        this.costdata.extras = "";
        this.costdata.total = "";
        this.costdata.profit_per = "";
        this.costdata.tot_cons = 0;
        this.costdata.tot_rate = 0;
        this.costdata.profit = "";
        this.costdata.round_off = "";
        this.costdata.sale_rate = "";
        this.costdata.mrp_per = "";
        this.costdata.mrp_rate = "";
        this.costdata.rnd = "";
        this.costdata.mrp_total = "";
        this.costdata.category = "";
      }

      //this.shadeList = res.shade;
      else {
        this.costdata.samp_id = res.data[0].samp_id;

        //  this.costdata.mshade = res.data[0].mshade;
        this.costdata.width = res.data[0].width;
        this.costdata.rate = res.data[0].rate;
        this.costdata.fconsumption = res.data[0].fconsumption;
        this.costdata.brand = res.data[0].brand;
        this.costdata.style = res.data[0].style;
        this.costdata.tech_style = res.data[0].tech_style;
        this.costdata.kaja = res.data[0].kaja;
        this.costdata.button = res.data[0].button;
        this.costdata.but_thread = res.data[0].but_thread;
        this.costdata.style_no = res.data[0].style_no;

        this.getDesignList(this.costdata.cost_samp_id);
        //  this.calcRate()
      }
    });
  }

  isCheckSample(status) {
    if (this.mode == "Add") {
      if (status.checked == true) {
        this.costdata.ischecked = "YES";
        if (trim(this.costdata.fabric_design_type) == "NEW") {
          this.costdata.shirt_design_type = "NEW";
          this.generateDNo(this.costdata.style);
        } else {
          this.costdata.shirtdno = this.costdata.mdesign_no;
        }
      } else {
        this.costdata.ischecked = "NO";
        this.costdata.shirtdno = "";
      }
    } else {
      let that = this;
      if (status.checked == true) {
        that.costdata.ischecked = "YES";
        this.costdata.shirtdno = that.costdata.shirtdno;
      } else {
        that.costdata.ischecked = "NO";
        that.costdata.shirtdno = "";
      }
    }
  }
  generateDNo(style) {
    let params = {
      style: style,
    };
    this.costservice.getDesignNo(params).then((res: any) => {
      this.costdata.shirtdno = res.data[0].shirtdno;
    });
  }

  getDesignList(cost_sample_id) {
    this.sample = {};
    let row = Object.assign({}, this.row);
    this.data.groupList.push(row);
    let params = {
      cost_sample_id: cost_sample_id,
      fab_design: this.costdata.fab_design,
    };
    let that = this;
    that.costservice.sampleDesignList(params).then((res: any) => {
      that.swatchList = res.color;
      if (res.match.length > 0) {
        that.matchList = res.match;
      } else {
        that.matchList = [{}];
      }
    });
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      match_color = this.matchList[ind]["match_color"],
      cons = this.matchList[ind]["cons"],
      rate = this.matchList[ind]["rate"];

    let nxtRow = $("#row-" + ind).next("tr");

    if (match_color != "") {
      if (fld == "match" && nxtRow.length == 0) {
        for (let i = 0; i < this.matchList.length; i++) {
          if (ind + 1 == this.matchList.length) {
            this.matchList.push({
              match_color: "",
              cons: "",
              rate: "",
            });

            nxtInd = this.matchList.length - 1;
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  onDeleteRow($event, fld, ind) {
    if (this.matchList.length > 1) {
      this.matchList.splice(ind, 1);

      if ($("#" + fld + "-" + (ind - 1)).length > 0) {
        $("#" + fld + "-" + (ind - 1)).focus();
      } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
        $("#" + fld + "-" + (ind + 1)).focus();
      }
    }
    this.calcMatchTot();
  }

  calcRate() {
    let nan = function (no) {
      if (no == "" || no == null || no == undefined) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    this.costdata.clothRate = (
      this.costdata.rate + this.costdata.lc_rate
    ).toFixed(2);
    this.costdata.cloth_rate = (
      this.costdata.clothRate * this.costdata.cons
    ).toFixed(2);
    this.costdata.matchRate = this.costdata.total_matchrate;
    this.costdata.match_rate = this.costdata.matchRate * 2;
    this.costdata.total =
      nan(this.costdata.cloth_rate) +
      nan(this.costdata.match_rate) +
      nan(this.costdata.trims_cost) +
      nan(this.costdata.making_cost) +
      nan(this.costdata.others);
    //  this.costdata.profit = ((this.costdata.total*this.costdata.profit_per/100)+this.costdata.total).toFixed(2);
    this.costdata.profit = (
      (this.costdata.total / (100 - this.costdata.profit_per)) *
      100
    ).toFixed(2);
    if (!this.costdata.profit && !this.costdata.round_off) {
      this.costdata.dp = this.costdata.total;
      return 1;
    } else {
      this.costdata.dp = (
        nan(this.costdata.profit) + nan(this.costdata.round_off)
      ).toFixed(2);
    }

    this.costdata.mu33 = (
      nan((this.costdata.dp * this.costdata.mu33_per) / 100) +
      nan(this.costdata.dp)
    ).toFixed(2);
    this.costdata.grand_total = (
      nan(this.costdata.tot_round) + nan(this.costdata.mu33)
    ).toFixed(2);
    this.costdata.mu38 = (
      nan((this.costdata.dp * this.costdata.mu38_per) / 100) +
      nan(this.costdata.dp)
    ).toFixed(2);
    this.costdata.ap_grand_total = (
      nan(this.costdata.ap_tot_round) + nan(this.costdata.mu38)
    ).toFixed(2);
    this.costdata.other_mrp = this.costdata.grand_total;
    this.costdata.ap_mrp = this.costdata.grand_total;
    // this.costdata.ap_mrp = this.costdata.ap_grand_total;

    if (trim(this.costdata.shirt_type) == "NEW") {
      let other_total = Math.round(this.costdata.grand_total);
      let ap_total = Math.round(this.costdata.ap_grand_total);
      this.setCategory(other_total);

      // this.apgategory(ap_total);
    } else if (trim(this.costdata.shirt_type) == "CORE") {
      let other_total = Math.round(this.costdata.grand_total);
      let ap_total = Math.round(this.costdata.ap_grand_total);
      // this.costdata.other_category = this.costdata.shirt_design;
      // this.costdata.ap_category = this.costdata.shirt_design;
      this.setCategory(other_total);

    }
    else if (trim(this.costdata.shirt_type) == "PLAIN") {
      let other_total = Math.round(this.costdata.grand_total);
      let ap_total = Math.round(this.costdata.ap_grand_total);
      // this.costdata.other_category = this.costdata.shirt_design;
      // this.costdata.ap_category = this.costdata.shirt_design;
      this.setCategory(other_total);

    }

  }
  //category from cost
  apgategory(ap_mrp) {
    let that = this;
    let params = {
      mrp: ap_mrp,
      brand: that.costdata.brand,
    };
    this.costservice.apgategory(params).then((res: any) => {
      if (res.data) {
        that.costdata.ap_category = res.data.category;
      } else {
        that.costdata.ap_category = "";
      }
    });
  }
  setCategory(other_total) {
    this.saveDetect = false;
    let setCategory = this.categoryData.filter((el) => el.mrp == other_total);
    this.categoryList = [];
    if (setCategory.length > 1) {
      this.categoryList = setCategory;
    }
    else if(setCategory.length > 0){

      this.saveDetect =  true;
      this.costdata.other_category = setCategory[0].category;
      this.costdata.fs_rate = setCategory[0].fs_rate;
      this.costdata.hs_rate = setCategory[0].hs_rate;

      this.costdata.ap_category = setCategory[0].category;
    } else {
        this.costdata.other_category = "";
        this.costdata.fs_rate = "";
        this.costdata.hs_rate = "";
        this.costdata.ap_category = "";
      }
  }

  onSelectCategory(category){

    let setCategory = this.categoryData.filter((el) => el.category == category);
    this.saveDetect =  true;
    this.costdata.fs_rate = setCategory[0].fs_rate;
    this.costdata.hs_rate = setCategory[0].hs_rate;

    this.costdata.ap_category = setCategory[0].category;

  }


  getCategory() {
    this.saveDetect = false;
    let that = this,
      params = {
        brand: that.costdata.brand,
      };
    that.costservice.getCategory(params).then((res: any) => {
        this.saveDetect = true;
      if (res.data.length > 0) {
        that.categoryData = res.data;
      } else {
        that.costdata.other_category = "";
        that.costdata.ap_category = "";
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/costingSample/costingSample.ts